module.exports = __webpack_public_path__ + "img/SEJ enventos_logo_educacion.1f50a55a.svg";